import { render, staticRenderFns } from "./TransportActionListMenu.vue?vue&type=template&id=c5fd28d6&"
import script from "./TransportActionListMenu.vue?vue&type=script&lang=js&"
export * from "./TransportActionListMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports